<i class="ti-pencil" (click)="openModal(category_edit)"></i>
<ng-template #category_edit>
    <form [formGroup]="modalForm" class="category_edit">
        <div class="modal-body">
            <input *ngFor="let item of propertiesArray" type="type" [formControlName]="item" />
            <div class="d-flex justify-content-between m-b-10 modal-checkbox">
                <div *ngFor="let checkboxControl of checkBoxesControls | slice:1; let i=index" class="m-r-20 checkbox-item">
                    <span *ngIf="getQuestionCategoryTypeByIndex(i) == questionCategoryType.ForProjectTeam" [feature]="feature.pme">
                        <input [name]="i" type="checkbox" [formControl]="checkboxControl" [checked]="checkboxControl.value" [id]="i" class="with-gap">
                        <label class="answer-text" [for]="i">{{ getCheckboxLabel(i) }}</label>
                    </span>
                    <span *ngIf="getQuestionCategoryTypeByIndex(i) != questionCategoryType.ForProjectTeam">
                        <input [name]="i" type="checkbox" [formControl]="checkboxControl" [checked]="checkboxControl.value" [id]="i" class="with-gap">
                        <label class="answer-text" [for]="i">{{ getCheckboxLabel(i) }}</label>
                    </span>
                </div>
            </div>
            <div class="btn-modal">
                <span (click)="onSave()" [class.disabled]="isOnSaving">{{ 'lang.common.btn.yes'  | translate}}</span>
                <span (click)="modalRef.hide()">{{ 'lang.common.btn.cancel'  | translate}}</span>
            </div>
        </div>
    </form>
</ng-template>
